// Backend sends over full Uri, but URL construction for update requests only needs the last few characters
export const extractLuidFromFieldConceptUri = (uri: string): string => {
  const matches: RegExpExecArray = /ontologies\/.+\/fieldConcepts\/(.+)/.exec(uri);
  return matches && matches[1] || '';
};
